var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOxxoicon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "54.000000pt",
    height: "30.000000pt",
    viewBox: "0 0 54.000000 30.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,30.000000) scale(0.100000,-0.100000)",
    fill: "#000000",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30 265 c-11 -13 17 -15 240 -15 223 0 251 2 240 15 -10 13 -50 15 -240 15 -190 0 -230 -2 -240 -15z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20 150 l0 -80 58 0 c65 0 73 4 107 50 l24 33 -19 25 c-11 13 -20 29 -20 33 0 18 28 8 43 -13 l15 -23 19 24 c28 35 50 18 24 -18 -11 -15 -19 -36 -18 -46 1 -13 -4 -20 -17 -20 -10 0 -25 -10 -33 -23 l-15 -22 166 0 166 0 0 80 0 80 -64 0 c-63 0 -65 -1 -96 -40 l-32 -40 22 -27 c15 -19 18 -29 10 -37 -8 -8 -17 -4 -31 14 l-19 25 -19 -25 c-14 -18 -23 -22 -31 -14 -8 8 -5 18 9 35 11 14 19 34 18 45 -1 12 3 18 14 16 9 -1 24 9 33 23 l16 25 -165 0 -165 0 0 -80z m128 54 c47 -32 16 -124 -42 -124 -37 0 -69 32 -69 68 0 62 60 92 111 56z m330 0 c16 -11 22 -25 22 -54 0 -29 -6 -43 -22 -54 -48 -34 -111 -4 -111 52 0 62 60 92 111 56z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70 171 c-22 -43 29 -83 60 -47 6 8 10 25 8 38 -4 32 -52 38 -68 9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407 183 c-11 -10 -8 -61 4 -68 16 -10 56 3 63 21 13 35 -41 74 -67 47z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25 40 c8 -14 482 -14 490 0 4 7 -80 10 -245 10 -165 0 -249 -3 -245 -10z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOxxoicon);
export default __webpack_public_path__ + "static/media/oxxoicon.9c139a81b84b86b6924517d205bee46e.svg";
export { ForwardRef as ReactComponent };